import PipelineLayout from '@/layouts/PipelineLayout.vue'

export const PIPELINE_ROUTES = [
  {
    path: 'pipelines',
    component: PipelineLayout,
    redirect: { name: 'EditNewLeadsPipeline' },
    children: [
      {
        path: 'new_leads/edit',
        name: 'EditNewLeadsPipeline',
        component: () => import('./views/EditNewLeadsPipeline.vue'),
      },
      {
        path: 'pending_quotes/edit',
        name: 'EditPendingQuotesPipeline',
        component: () => import('./views/EditPendingQuotesPipeline.vue'),
      },
      {
        path: 'pending_jobs/edit',
        name: 'EditPendingJobsPipeline',
        component: () => import('./views/EditPendingJobsPipeline.vue'),
      },
    ],
  },
]
